import { useEffect, useRef, useState } from 'react';
import { Button } from 'react-bootstrap';
import { FaCheckCircle } from 'react-icons/fa';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { Link, useNavigate, useParams } from 'react-router-dom';
import ResendOTP from '../Pages/auth/components/ResendOTP';
import FrontFooter from '../Pages/front/components/FrontFooter';
import FrontNav from '../Pages/front/components/FrontNav';
import { loginWithOtp } from '../Redux/slices/user';
import { fetchWrapper } from '../_helpers/fetchWrapper';
import OTPInput from './OTPInput';

function SuccessfulSignUp() {
  const { type, email } = useParams();
  const navigator = useNavigate();
  const dispatch = useDispatch();
  const [OTP, setOTP] = useState('');
  const [counter, setCounter] = useState(59);
  const appliedEvent = useSelector((state) => state.event.appliedEvent);
  useEffect(() => {
    const timer = counter > 0 && setInterval(() => setCounter(counter - 1), 1000);
    return () => clearInterval(timer);
  }, [counter]);

  const handleVerifiyOTP = async () => {
    try {
      let redirectTo = false;
      if (appliedEvent) {
        redirectTo = '/events/' + appliedEvent;
      }
      dispatch(loginWithOtp({ username: email, otp: OTP.join('') }, navigator, redirectTo));
    } catch (err) {
      console.log(err);
    }
  };

  const resetOTP = useRef(null);

  const handleOTPChange = (OTP) => {
    setOTP(OTP);
  };

  useEffect(() => {
    try {
      const callOTP = async () => {
        await fetchWrapper.post('/resend-otp/', {
          username: email
        });
      };
      if (type === 'trainee') {
        callOTP();
      }
    } catch (err) {
      console.log(err);
    }
  }, []);

  return (
    <div className="front">
      <FrontNav />
      <section className="pt-4 pt-md-4 bg-gray-200">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="card">
                <div className="card-header">
                  <div className="d-flex justify-content-between align-items-center">
                    <h1 className="mb-0">
                      {type === 'roster' ? (
                        <FormattedMessage id="resource_person_registration" />
                      ) : (
                        <FormattedMessage id="participant_registration" />
                      )}
                    </h1>
                  </div>
                </div>
                <div className="card-body pt-2 ">
                  <div>
                    <div className="alert alert-success d-flex align-items-center justify-content-inline mb-0">
                      <FaCheckCircle size={50} className="me-3 text-success" />
                      <p className="px-3 mb-0 w-100">
                        <h4 className="text-primary">
                          <FormattedMessage id="congratulation" />
                        </h4>
                        <FormattedMessage id="success_msg" />
                        <FormattedMessage id="please_check_your_email" /> <br />
                        <FormattedMessage id="your_email" /> <b>{email}</b> <br />
                        <FormattedMessage id="thank_you" />
                      </p>
                    </div>

                    {type === 'trainee' ? (
                      <div className="py-3 text-center">
                        <FormattedMessage id="registration.otpmessage" />
                        <div className="mt-2">
                          <div className="d-flex flex-row justify-content-center mt-2">
                            <OTPInput OTP={OTP} setOTP={handleOTPChange} reset={resetOTP} />
                          </div>
                          <div className="mt-2 w-100 d-flex justify-content-center">
                            <ResendOTP
                              username={email}
                              counter={counter}
                              handleOTPReset={() => resetOTP.current()}
                              setCounter={setCounter}
                            />
                          </div>
                          <div className="d-flex justify-content-center align-items-center">
                            <Button variant="success" onClick={handleVerifiyOTP} type="submit">
                              <FormattedMessage id="registration.verifyAndProceed" />
                            </Button>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <p>
                        <br />
                        <div className="mt-2">
                          <Link to="/" className="mt-2">
                            <Button variant="success">
                              <FormattedMessage id="gotohome" />
                            </Button>
                          </Link>
                        </div>
                      </p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="position-relative mt-n15">
        <div className="shape shape-bottom shape-fluid-x bg-text-dark">
          <svg viewBox="0 0 2880 48" fill="none" xmlns="../www.w3.org/2000/svg.html">
            <path d="M0 48h2880V0h-720C1442.5 52 720 0 720 0H0v48z" fill="currentColor" />
          </svg>
        </div>
      </div>
      <section className="pt-15 bg-dark" />
      <section className="py-8 py-md-11 bg-dark" />
      <div className="position-relative">
        <div className="shape shape-bottom shape-fluid-x text-gray-200">
          <svg viewBox="0 0 2880 48" fill="none" xmlns="../www.w3.org/2000/svg.html">
            <path d="M0 48h2880V0h-720C1442.5 52 720 0 720 0H0v48z" fill="currentColor" />
          </svg>
        </div>
      </div>

      <FrontFooter />
    </div>
  );
}

export default SuccessfulSignUp;
